<!--
 * @Description:
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <!-- 这里的样式是为了和表格对齐 !!!-->
    <div style="padding:0 1.56vw">
      <!--      <el-button type="primary" size="default" @click="back">返回</el-button> -->
    </div>
    <table-render
      ref="tableRender"
      :config="config"
      :propData="{ query }"
      @respondFinished="res => (respond = res)"
    />

    <div style="padding:0 1.56vw ">
      <el-form :inline="true" size="mini" label-suffix="： ">
        <el-form-item label="核算终端结算总金额">
          <el-input
            disabled
            :value="moneyFixed(respond.CsoPriceSumTotal)"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目支付金额（结算总价合计）">
          <el-input
            disabled
            :value="moneyFixed(respond.totalPricesTotal)"
          ></el-input>
        </el-form-item>
        <detail-of-project :data="respond.projectStatistics" />
      </el-form>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import {
  dakuan,
  dakuanWT,
  dakuanWTGeti,
  dakuanGeti
} from './projectPriceTable.config';
import { moneyFixed } from '@/tools/money';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  name: 'projectPrice',
  components: {
    tableRender,
    detailOfProject: () => import('./detail-of-project')
  },
  computed: {
    bankText() {
      return payBankFormatter(this.respond);
    }
  },
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      config: null,
      respond: {}
    };
  },
  created() {
    const isPark =
      +this.query._invoiceBusinessType === 3 ||
      +this.query.userEnterpriseType === 3;
    // +this.query._invoiceBusinessType === 2;
    // 委托代开
    if (+this.query.stateType === 3) {
      if (isPark) {
        this.config = dakuanWTGeti;
      } else {
        this.config = dakuanWT;
      }
      return;
    }
    if (isPark) {
      this.config = dakuanGeti;
    } else {
      this.config = dakuan;
    }
  },
  methods: {
    moneyFixed,
    back() {
      this.$xrkDialog.clear();
    }
  }
};
</script>
